import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeDetectorService {

  isSystemDarkMode(): boolean {
    if (!window || !window.matchMedia) {
      return false; // fallback
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
}
